// 修正手機版 Quick Add 取消無法點擊 Bug
document.body.addEventListener('click', function(e){
  const btn = e.target.closest('[data-cancel-quickshop-popup]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const variantsPopup = btn.closest('.variants-popup');
  if (variantsPopup) variantsPopup.style.visibility = 'hidden';
  const haloWrapper = document.querySelector('.halo-popup-wrapper');
  if (haloWrapper) haloWrapper.style.visibility = 'hidden';
  const haloPopup = document.querySelector('.halo-popup');
  if (haloPopup) haloPopup.style.visibility = 'hidden';
  const mobilePopup = document.querySelector('#halo-card-mobile-popup');
  if (mobilePopup) mobilePopup.style.visibility = 'hidden';
  document.body.style.overflow = '';
  console.log('✅ all popups set to visibility:hidden');
}, true);